<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

        <material-card
            :color="app.color"
            isContract   
          >
          <v-layout wrap slot="header">
            <v-flex sm6 xs12>
              <span class="title">{{contract.title}}</span><br>
              <span class="body-1">{{contract.template.subtitle}}</span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex sm4 xs12 class="text-right">

                  <!-- <span v-if="object.details.name !== undefined" class="title" style="cursor:pointer;" @click="toObject({reference:object.reference})" >{{object.details.name}}</span><br> -->
                  <!-- <span v-if="object.details.name !== undefined" class="body-1" >{{object.subtitle}}</span> -->



            </v-flex>           
          </v-layout>

          <!-- toolbar for activities -->
          <v-container fluid class="pa-3" >
            <v-layout row> 
              <v-flex class="pl-4">
                <v-tooltip right="" dark="" v-if="!app.contract.hasChange && contract.parent">
                  <template #activator='data'>
                    <v-btn medium text icon color="transparent">
                      <v-icon @click="toObject({reference:contract.parent})" v-on="data.on" :color="app.color">mdi-backspace</v-icon>
                    </v-btn>                  
                  </template>
                  <span>Naar {{contract.template.parties[0].name}} </span>
                </v-tooltip>    
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex class="text-sm-right">
                <v-btn v-if="!app.merkato.show" text class="pa-2 body-2" medium :color="contract.status.color" >Status : {{contract.status.title}}</v-btn>
              </v-flex>
            </v-layout>
          </v-container>

          <v-expand-transition v-if="!app.merkato.show">

            <v-container fluid>
                
                <!-- autoselects to match parties to the contract -->
              <v-form v-model="app.contract.valid">

                <v-layout>

                  <v-flex style="padding:25px" md4 sm6 xs12>
                    <v-layout>
                        <v-autocomplete 
                          :rules="required"
                          dense
                          :label="contract.template.parties[0].name"
                          v-model="contract['parent']"
                          :items="getItems(contract.template.parties[0].objects.reference)"
                          item-text="details.name"
                          item-value="reference"
                          :prepend-icon="contract.template.parties[0].objects.icon"
                          hide-selected
                          :disabled="contract.status.id > 0"
                          @change="change()"
                          >                        
                        </v-autocomplete>
                      </v-layout>
                  </v-flex>

                </v-layout>
                <v-layout>
                  <v-flex style="padding:25px" md4 sm6 xs12
                  v-if="index > 0"
                    v-for="(item, index) in contract.template.parties" :key="index">
                    <v-layout row>
                      <v-autocomplete 
                        v-if="index > 0"
                        dense
                        :label="contract.template.parties[index].name"
                        v-model="contract['party_' + (index)]"
                        :items="getItems(contract.template.parties[index].objects[0].reference)"
                        item-text="details.name"
                        item-value="reference"
                        :prepend-icon="contract.template.parties[index].objects[0].icon"
                        hide-selected
                        :disabled="contract.status.id > 0"
                        @change="change()"
                        >

                      <template v-slot:append-outer v-if="contract.status.id == 0">
                        <v-slide-x-reverse-transition
                          mode="out-in"
                        >
                          <v-icon
                            :color="hasValue(contract['party_' + (index)]) ? 'error' : 'success'"
                            v-text="hasValue(contract['party_' + (index)]) ? 'mdi-minus' : 'mdi-plus'"
                            @click="setField('party_' + (index), index)"
                          ></v-icon>                 
                        </v-slide-x-reverse-transition>
                      </template>                      
                      </v-autocomplete>


                  </v-layout>
                </v-flex>
              </v-layout>

                <v-row align="baseline">   
                  
                    <v-flex md4 sm6 xs12 >
                        <v-autocomplete
                          v-if="!noDuration"
                          :disabled="contract.status.id != 0"
                          v-model="contract.duration"
                          :items="contract.template.durations"
                          dense=""
                          item-text="title"
                          item-value="id"
                          label="Contract duur"
                          prepend-icon="mdi-calendar"
                          @change="change()"
                          >
                        </v-autocomplete>
                    </v-flex>
                    
                    <v-flex md4 sm6 xs12>
                        <contract-start-date
                        v-if="!noDuration" 
                        :disabled="contract.duration == null || contract.status.id != 0" 
                        label="Startdatum" field="start_date"></contract-start-date>

                    </v-flex>
                    
                    <contract-expiration-date v-if="!noDuration && contract.duration == 1" :disabled="contract.duration == null || contract.status.id != 0" label="Einddatum" field="expiration_date"></contract-expiration-date>

                </v-row>

              </v-form>

              <forms-add-object inContract v-if="object_details!=null" :index="index" :object="object_details"></forms-add-object>            

              <!-- buttons for accepting changes -->
              <v-layout justify-end="" style="min-height:78px;" v-if="contract.status.id == 0">

                <v-flex md2 xs6>
                    <v-slide-x-transition>
                        <v-btn rounded="" block="" v-if="app.contract.hasChange && !app.contract.loading"  @click="resetContract()" color="warning">Reset</v-btn>
                    </v-slide-x-transition>
                </v-flex>
                <v-flex md2 xs6>
                    <v-slide-x-transition>
                        <v-btn rounded="" block="" v-if="app.contract.hasChange && !app.contract.loading" :disabled="!app.contract.valid" @click="updateContract()" color="success">Opslaan</v-btn>
                    </v-slide-x-transition>
                </v-flex>
              </v-layout>            
            </v-container>
          </v-expand-transition>

          <core-show-contract v-if="contract.status.id == 0"></core-show-contract>

          <core-merkato></core-merkato>

          <v-layout v-if="contract.status.id > 0" wrap>
            <v-flex md7 xs12>
              <document-show-log logType="contract"></document-show-log>
            </v-flex>
            <v-flex md5 xs12>
              <document-show-pdf></document-show-pdf>
            </v-flex>
          </v-layout>

        </material-card>
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      object_details: null,
      index: null,
      dateRules: [
        v => moment(v, "DD-MM-YYYY").isValid() || "Datum is niet geldig",
        v =>
          moment(v, "DD-MM-YYYY").isAfter(moment("01-01-1900")) ||
          "Datum ligt te ver in het verleden"
      ],
      required: [v => !!v || "Invoer is verplicht."]
    };
  },
  computed: {
    ...mapState(["object", "app", "contract", "contracts", "templates"]),
    noDuration() {
      if (this.$store.state.contract.template.durations.length == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(["resetContract", "updateContract", "toObject", "newObject"]),
    getItems(reference) {
      var items = this.$store.state.objects.filter(
        item => item.category.reference == reference
      );
      return items;
    },
    change() {
      this.$store.state.app.contract.hasChange = true;
    },
    hasValue(field) {
      if (field != null) {
        return true;
      } else {
        return false;
      }
    },
    setField(field, index) {
      if (index == 0) {
        this.object_details = this.contract.template.parties[index].objects;
      } else {
        this.object_details = this.contract.template.parties[index].objects[0];
      }

      this.index = index;

      if (this.$store.state.contract[field] == null) {
        this.$store.dispatch("newObject");
      } else {
        this.$store.state.contract[field] = null;
        this.$store.state.app.contract.hasChange = true;
      }
    }
  },
  created() {
    this.$store.dispatch("checkAuth");
  },
  beforeDestroy() {
    (this.$store.state.pdfStore.show = false),
      (this.$store.state.pdfStore.file = ""),
      (this.$store.state.pdfStore.available = false),
      (this.$store.state.pdfStore.download = null);
    if (this.$store.state.app.contract.hasChange == true) {
      this.resetContract();
    }
    console.log("destroing");
    this.$store.state.app.merkato.show = false;
    this.$store.state.app.merkato.load = false;
  }
};
</script>